<app-form-resbsk
    [requestList]="requestList"
    [basketList]="basketList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-resbsk>